import React from 'react';

const ContactButtons = () => {
  return (
    <div 
      className="contact-buttons" 
      style={{
        position: 'fixed', 
        bottom: '20px', 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '0 20px', 
        zIndex: 1000,
        pointerEvents: 'none', 
      }}
    >
      
      <a 
        href="tel:+918956322311" 
        className="call-button" 
        style={{
          backgroundColor: '#1F155C', 
        
          borderRadius: '50%',
          border : '1px solid white',
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001, // Ensure button is above the container
          pointerEvents: 'auto', // Allow clicks on this specific button
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1F155C')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#1F155C')}
      >
        <img src="./images/call.webp" alt="Call" style={{ width: '30px', height: '30px' }} />
      </a>

      <a 
      href="https://wa.me/+918956322311?text=Hello%20Wallabies%20Warm%20Care%20Team%2C%0A%0A%20I%20would%20like%20to%20inquire%20about%20your%20forced%20air-warming%20systems%20and%20forced%20air-warming%20blankets.%20Wallabies%20Warm%20Care%20is%20the%20leading%20producer%20and%20supplier%20of%20these%20high-quality%20products.%20Please%20let%20me%20know%20more%20about%20the%20available%20options%20and%20pricing.%20Thank%20you%21"


        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#25D366', 
          borderRadius: '50%', 
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001,
          pointerEvents: 'auto', 
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1DAE3E')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
      >
        <img src="./images/whatsapp.webp" alt="WhatsApp" style={{ width: '30px', height: '30px' }} />
      </a>

    </div>
  );
};

export default ContactButtons;

